import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import Modal from 'Shared/Modal';
import { AboutNova } from '../AboutNova';
import {
  AboutModalTitleText,
  AboutModalContentContainer,
  AboutModalTitleContainer,
} from './styles';

interface AboutNovaModalProps {
  onClose(): void;
}

export const AboutNovaModal = ({ onClose }: AboutNovaModalProps) => {
  const [show, setShow] = useState(true);
  const { t: translate } = useTranslation('chatbot');

  const handleModalClose = () => {
    setShow(false);
    onClose();
  };

  return (
    <Modal
      open={show}
      onCloseCallback={handleModalClose}
      closeHeader={true}
      size="medium"
      modalContent={() => (
        <>
          <AboutModalTitleContainer>
            <AboutModalTitleText>
              {translate('modals.about_nova.title')}
            </AboutModalTitleText>
          </AboutModalTitleContainer>
          <AboutModalContentContainer>
            <AboutNova inModal={true} />
          </AboutModalContentContainer>
        </>
      )}
    />
  );
};
